module.exports = __webpack_public_path__ + "img/cloth_g1_shoe_08.58cd4f0e.svg";